<template>
    <v-dialog v-model="mostrar" persistent width="500px">
        <v-card :loading="loading">
            <v-toolbar color="blue-grey darken-2" dark>
                <v-toolbar-title>Agregar transferencia</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-col>
                        <v-menu
                        v-model="fechaPicker"
                        :close-on-content-click="false"
                        max-width="290"
                        >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="fechaTexto"
                            label="Fecha:"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        color="blue-grey darken-2"
                            v-model="fecha"
                            locale="es"
                            @change="fechaPicker = false"
                            ></v-date-picker>
                         </v-menu>
                    </v-col>
                    <!-- <v-col>
                        <v-autocomplete label="Unidad admnistrativa" v-model="selectedDependencia" :items="dependencias" hide-details="auto" return-object item-text="nombre" autofocus></v-autocomplete>
                    </v-col> -->
                    
                </v-container>
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')" :disabled="loading" :loading="loading">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" @click="agregar()" dark :disabled="loading" :loading="loading">Agregar</v-btn>
            
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
// import { getDependencias } from '../expedientes/expediente.service';
import {DateTime} from 'luxon'
import { guardarTransferencia } from './transferencias.service'
export default {
    name:"agregarTransferencia",
    props:['mostrar'],
    data: () => ({
       
        loading: false,
        dependencias: [],
        selectedDependencia: null,
        fecha: '',
        fechaPicker:false,
    }),
    computed: {
        fechaTexto() {
            return  this.fecha ? DateTime.fromFormat(this.fecha, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy")  : ''
        }
    },
    async created() {
        // try {
            
            
        // } catch (error) {
        //     this.$notificarError(error);
        // }
    },
    methods:{
        async agregar(){
            try{
                const data = { fechaTransferencia: this.fecha }
                this.loading=true;

                const serverResponse = await guardarTransferencia(data)
                this.loading=false;
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.$emit('agregada', serverResponse.transferencia)
                this.$emit('cancelar')

            }catch(error){
                this.$notificarError(error);
            }
        }
        

    }
}


</script>